import { RegistryVariable } from "../registry/sitePageRegistry";

const TOKEN_PATTERN = /\{\{(\w+)\}\}/g;

export type TemplateSegment = { type: "text"; value: string } | { type: "token"; key: string };

// Splits a raw template string ("{{title}} | Site") into literal-text and
// token segments so the editor can render each token as an inline chip.
export const splitTemplate = (raw: string): TemplateSegment[] => {
  const segments: TemplateSegment[] = [];
  let lastIndex = 0;
  for (const match of raw.matchAll(TOKEN_PATTERN)) {
    const index = match.index ?? 0;
    if (index > lastIndex) segments.push({ type: "text", value: raw.slice(lastIndex, index) });
    segments.push({ type: "token", key: match[1] });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < raw.length) segments.push({ type: "text", value: raw.slice(lastIndex) });
  return segments;
};

const findVariable = (variables: RegistryVariable[], key: string) => variables.find((variable) => variable.key === key);

// What marketing sees: tokens replaced by sample values, so they get a real
// feel for the output rather than reading raw {{tokens}}.
export const resolveTemplateForPreview = (raw: string, variables: RegistryVariable[]): string =>
  splitTemplate(raw)
    .map((segment) => {
      if (segment.type === "text") return segment.value;
      const variable = findVariable(variables, segment.key);
      return variable ? variable.sample : `{{${segment.key}}}`;
    })
    .join("");
